import React, {useEffect, useState} from 'react'

import Box from '../../component/Box/Box'
import Loading from '../../component/Loading/Loading'
import Page from '../../component/Page/Page'
import Notify from '../../services/Notify'
import {ReadpointCheckpointTargetService} from '../../services/ReadpointCheckpointTargetService'
import ReadpointService from '../../services/ReadpointService'
import {ReadpointCheckpointTargetForm} from './ReadpointCheckpointTargetForm'

export function ReadpointCheckpointTargetPage({history, match}) {

  const [readpoint, setReadpoint] = useState(null)

  const getReadpoint = async (id) => {
    try {
      return setReadpoint(await new ReadpointService().getReadPointById(id))
    } catch (error) {
      Notify.error('Erro ao buscar ponto de leitura', error)
    }
  } 

  useEffect(() => {
    if (match.params && match.params.readpointId) {
      getReadpoint(match.params.readpointId)
    }
  }, [])

  return (
      <Page title="Configuração do Tipo de Portal">
        <Box>
          {
            !readpoint ? <Loading /> :
            <ReadpointCheckpointTargetForm
              history={history} 
              readpointTarget={readpoint}
            /> 
          }
        </Box>
      </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/ReadpointCheckpointTargetPage/ReadpointCheckpointTargetPage.js